import { render, staticRenderFns } from "./MdTable.vue?vue&type=template&id=5966abd0&"
import script from "./MdTable.vue?vue&type=script&lang=js&"
export * from "./MdTable.vue?vue&type=script&lang=js&"
import style0 from "./MdTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports